// Central contact point. All former Subscribe/Buy/View-Subscription CTAs now open
// Madam Precious' WhatsApp so buyers can pay her directly.
export const WHATSAPP_PHONE = "2348068833390";
export const WHATSAPP_SALES_TEXT = "Hi Madam Precious, I'd like to buy this week's games.";
export const WHATSAPP_SALES_URL = `https://wa.me/${WHATSAPP_PHONE}?text=${encodeURIComponent(WHATSAPP_SALES_TEXT)}`;

/**
 * Opens the WhatsApp sales chat in a new tab.
 * Pass a custom message to override the default greeting.
 */
export const openWhatsAppSales = (message) => {
  const url = message
    ? `https://wa.me/${WHATSAPP_PHONE}?text=${encodeURIComponent(message)}`
    : WHATSAPP_SALES_URL;
  if (typeof window !== "undefined") {
    window.open(url, "_blank", "noopener,noreferrer");
  }
};

export default WHATSAPP_SALES_URL;
